module.exports = __webpack_public_path__ + "static/7i-8c98142b425630821139c24bd1698700.woff";